import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinSync',
  props: {
    orgTwin: {
      type: Object,
      required: true
    },
    orgTwinStates: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      formValid: false,
      twinSearch: null,
      syncingTwins: [],
      syncMetaData: ['icon'],
      statesSync: {},
      errornousTwinId: -1
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    twinMetaItems: function twinMetaItems() {
      return [{
        value: 'title',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle')
      }, {
        value: 'type',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.twinType')
      }, {
        value: 'icon',
        text: this.$i18n_t('Common.icon')
      }, {
        value: 'tags',
        text: this.$i18n_t('Common.tags')
      }, {
        value: 'polygonRadius',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.autoPolygonRadius')
      }, {
        value: 'floorDtwinId',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }];
    },
    stateMetaItems: function stateMetaItems() {
      return [{
        value: 'title',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title')
      }, {
        value: 'unit',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.unit')
      }, {
        value: 'icon',
        text: this.$i18n_t('Common.icon')
      }, {
        value: 'visualization',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.visualization.panelTitle')
      }, {
        value: 'transformer',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.states.transformer')
      }];
    }
  }),
  watch: {
    orgTwinStates: function orgTwinStates() {
      if (this.orgTwinStates !== null) {
        this.loadStates();
      }
    }
  },
  mounted: function mounted() {
    if (this.orgTwinStates !== null) {
      this.loadStates();
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    loadStates: function loadStates() {
      var _this = this;

      this.statesSync = {};
      this.orgTwinStates.forEach(function (state) {
        _this.statesSync[state.key] = [];
      });

      if (this.orgTwinStates.length) {
        this.statesSync[this.orgTwinStates[0].key] = ['icon'];
      }
    },
    syncingTwinSelected: function syncingTwinSelected(e) {
      this.syncingTwins.push(e);
    },
    syncingTwinDeselected: function syncingTwinDeselected(e) {
      this.syncingTwins = this.syncingTwins.filter(function (t) {
        return t.id !== e.id;
      });
      this.syncingTwins = cloneDeep(this.syncingTwins);
    },
    syncTwins: function syncTwins() {
      var _this2 = this;

      ApiService.digitalTwinSync(this.orgTwin.id, {
        twinIds: this.syncingTwins.map(function (t) {
          return t.id;
        }),
        states: this.statesSync,
        metaData: this.syncMetaData
      }).then(function (res) {
        _this2.$snack(_this2.$i18n_t('DigitalTwin.DigitalTwin.copy.syncSuccessSnack'), 'success');

        _this2.$emit('close', res);
      }).catch(function (error) {
        console.error(error.response);

        _this2.$snack(_this2.$i18n_t('DigitalTwin.DigitalTwin.copy.syncFailedSnack'), 'error');

        if (get(error, 'response.status') === 403 && get(error, 'response.data.data.twinId')) {
          _this2.errornousTwinId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }

        if (get(error, 'response.status') === 404 && get(error, 'response.data.data.twinId')) {
          _this2.errornousTwinId = parseInt(get(error, 'response.data.data.twinId'));
          return;
        }
      });
    }
  })
};